
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 1H4a2.006 2.006 0 00-2 2v13a1 1 0 002 0V4a1 1 0 011-1h10a1 1 0 000-2zm.59 4.59l4.83 4.83a2 2 0 01.58 1.41V21a2.006 2.006 0 01-2 2H7.99A2 2 0 016 21l.01-14A2 2 0 018 5h6.17c.533 0 1.044.213 1.42.59zM15 12h4.5L14 6.5V11a1 1 0 001 1z"}})])
          )
        }
      }
    